module.exports = __webpack_public_path__ + "static/img/teacher3.e86bbe31.png";